import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect
export const Route = createFileRoute('/dashboard/desa/')({
  beforeLoad: async () => {
    throw redirect({ to: '/platform/desa' })
  },
  component: () => null,
})
